import React, { Component } from 'react';
import moment from 'moment';

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="wrapper">
          <div className="text-center">{moment().format('YYYY')} © Leroy Merlin Dashboard. Estrutura base do React.</div>
        </div>
      </footer>
    );
  }
}

export default Footer;
